import { shape, string } from "prop-types";

const RiderType = shape({ id: string, name: string, phone: string });

export default RiderType;
